export const scriptExtBaseEndpoint =
  process.env.REACT_APP_SCRIPT_EXT_BASE_ENDPOINT;
export const geoJsonFile = 'qld_lga.geo.json';
export const dataFile = 'councils-data.json';

export const env =
  process.env.BRANCH != null && `${process.env.BRANCH}`.indexOf('staging') > -1
    ? 'staging'
    : process.env.NODE_ENV;

export const scriptInjectedFn = {
  _grant_hydrate: () => {},
  getDataFileEndpoint: () => {},
};



// WEBPACK FOOTER //
// ./src/config/index.js